import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ETLDataFeedViewObj } from '../cxone-etl-data-feed/cxone-etl-data-feed-view/cxone-etl-data-feed-view.model';
import { ETLDataFeedDependencies, ETLDataFeedObj, FailedImportObj } from './cxone-etl-data-feed.model';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';

@Injectable({
    providedIn: 'root'
})
export class CxoneEtlDataFeedService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    public async loadDataFeed(): Promise<ETLDataFeedObj[]> {
        try {
            const response = await this.cvApiService.get<ETLDataFeedObj[]>(`/api/v1/pipeline-config/raw-data-definitions`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load data feeds.`);
            throw error;
        }
    }

    public async loadDataFeedView(id: string): Promise<ETLDataFeedViewObj> {
        try {
            const response = await this.cvApiService.get<ETLDataFeedViewObj>(`/api/v1/pipeline-config/preview-raw-data?id=${id}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load data feed - view records.`);
            throw error;
        }
    }

    public async loadUnrecognizedDataFeed(): Promise<ETLDataFeedObj[]> {
        try {
            const response = await this.cvApiService.get<ETLDataFeedObj[]>(`/api/v1/pipeline-config/raw-data-unrecognized`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load unrecognized data feeds.`);
            throw error;
        }
    }

    public async loadFailedImports(apiType: string): Promise<FailedImportObj[]> {
        try {
            const response = await this.cvApiService.get<FailedImportObj[]>(`/api/v1/pipeline-config/failed-process-reports/${apiType}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load failed process reports.`);
            throw error;
        }
    }

    public async reactivateDataFeed(id: string): Promise<ApiResponse<void>> {
        try {
            const response = await this.cvApiService.post<void>(`/api/v2/pipeline/raw-data-definition/${id}/reactivate`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to reactivate data feed ${id}.`);
            throw error;
        }
    }

    public async getDataFeedDependencies(id: string): Promise<ETLDataFeedDependencies> {
        try {
            const response = await this.cvApiService.get<ETLDataFeedDependencies>(`/api/v1/pipeline-config/raw-data-rdepends?id=${id}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to retrive data feed dependencies ${id}.`);
            throw error;
        }
    }

    public async deleteDataFeed(id: string): Promise<void> {
        try {
            const response = await this.cvApiService.delete<void>(`/api/v1/pipeline-config/raw-data?id=${id}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to delete data feed ${id}.`);
            throw error;
        }
    }

    public async saveDataFeed(dataFeed): Promise<void> {
        try {
            const response = await this.cvApiService.post<void>(`/api/v2/pipeline/raw-data-definition/save-definition`, dataFeed);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to save data feed.`);
            throw error;
        }
    }

    async getPermissions(requestedPage:string) {
        try {
            const response = await this.cvApiService.get<string[]>(`/api/v1/general/pages/user-permissions/${requestedPage}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            throw error;
        }
    }
}

